<template>
    <div class="two-member-list-container">
      <van-nav-bar 
        title="二级推广组列表" 
        left-text="" 
        left-arrow 
        @click-left="onClickLeft" 
        @click-right="onClickRight"
        :style="{ backgroundColor: '#1a1a1a', color: '#ffffff' }"
        :title-style="{ color: '#ffffff' }"
        :left-arrow-style="{ color: '#ffffff' }"
      />
      
      <div class="content-wrapper">
        <!-- 搜索区域 -->
        <div class="search-section">
          <!-- 自定义搜索框（替换原来的 van-search） -->
          <div v-if="!!selfInfo" class="custom-search">
            <!-- 输入框容器 -->
            <div class="search-input-wrap">
              <input 
                type="text" 
                v-model="search" 
                placeholder="输入组长ID"
                class="search-input"
                @keyup.enter="onSearch" 
              >
            </div>
            <!-- 搜索按钮 -->
            <div class="search-action-btn" @click="onSearch">
              搜索
            </div>
          </div>
          
          <!-- 搜索类型选择 -->
          <div class="search-type-wrapper">
            <van-radio-group v-model="checked" class="radio-group" direction="horizontal">
              <van-radio name="0" icon-size="14px" class="radio-item">组长ID</van-radio>
              <van-radio name="2" icon-size="14px" class="radio-item">上级组长ID</van-radio>
            </van-radio-group>
          </div>
        </div>
        
        <!-- 成员列表 -->
        <van-list v-if="!!selfInfo" class="member-list" v-model:loading="loading" :immediate-check="false"
          :finished="finished" finished-text="没有更多了" @load="onLoad">
          
          <!-- 成员卡片 -->
          <div class="member-card" v-for="(li, i) in list" :key="i">
            <!-- 成员头部信息 -->
            <div class="member-header">
              <div class="avatar-container">
                <img :src="li.userInfo.portrait ? (config!=null ?config.fileServerUrl:'') + li.userInfo.portrait : muser" alt="头像" class="avatar" />
              </div>
              <div class="member-info">
                <h3 class="member-name">{{ li.userInfo.nickName }}</h3>
                <p class="join-time">加入时间：{{ getDisplayJoinTime(li.joinTime) }}</p>
              </div>
            </div>
            
            <!-- 成员数据信息 -->
            <div class="member-data">
              <div class="data-item" @click="onUidTapped(li)">
                <div class="data-value">{{ li.userId }}</div>
                <div class="data-label">组长ID</div>
              </div>
              <div class="data-item" @click="onParentIdTapped(li)">
                <div class="data-value">{{ li.num }}</div>
                <div class="data-label">人数</div>
              </div>
              <div class="data-item" @click="onUidTapped(li)">
                <div class="data-value">{{ li.preOwnerId }}</div>
                <div class="data-label">上级组长ID</div>
              </div>
            </div>
            
            <!-- 操作按钮 -->
            <div class="action-buttons">
              <div class="action-btn copy-btn" @click="onCopyUserIdTapped(li)">
                <i class="icon-copy">📋</i> 复制组长ID
              </div>
              <div class="action-btn income-btn" @click="onIncomeTapped(li)">
                <i class="icon-income">📊</i> 查看流水
              </div>
            </div>
          </div>
        </van-list>
        
        <!-- 确认弹窗 -->
        <van-popup v-model:show="confirm" :close-on-click-overlay="true">
          <div class="confirm-dialog">
            <div class="confirm-content">是否确认{{ isEnable ? '启用' : '禁用' }}该用户？</div>
            <van-button type="success" round size="small" @click="onConfirmTapped">确认</van-button>
          </div>
        </van-popup>
      </div>
      
      <Mask v-if="marke"></Mask>
    </div>
  </template>
  <script>
  import muser from "@/assets/image/user.png";
  // import { wxqq } from '../utils/utils'
  import Mask from '../components/Mask'
  import routerUtil from '../utils/routerUtil'
  import { Toast } from "vant";
  import copy from 'copy-to-clipboard';

  export default {
    name: 'MemberList',
    data() {
      return {
        search: '',
        checked: '0',
        muser,
        selfInfo: null,
        groupInfo: null,
        searchType: 0,
        searchUid: null,
        loading: false,
        finished: false,
        refreshing: false,
        list: [],
        confirm: false,
        item: null,
        isEnable: false,
        marke: false,
      }
    },
    components: {
      Mask,
    },
    computed: {
      config: () => {
        return JSON.parse(localStorage.getItem("config"));
      },
    },
    mounted() {
      this.reqInfo()
      // this.marke = wxqq()
    },
    methods: {
      reqInfo() {
        Promise.all([this.$request.post('/api/user/mine/userInfo'), this.$request.postJson('/api/user/pay_group/info', {})])
          .then((values) => {
            if (values[0].data.code == 0 && values[1].data.code == 0) {
              this.selfInfo = values[0].data.data;
              this.groupInfo = values[1].data.data;
              if (!this.groupInfo) {
                Toast('暂无推广组信息');
                routerUtil.back()
                return;
              }
              this.getList()
            }
          });
      },
      getList(type) {
        // eslint-disable-next-line no-debugger
        // debugger
        let lastId = null
        if (type && this.list.length > 0) {
          lastId = this.list[this.list.length - 1].id
        }
        this.$request.postJson('/api/user/pay_group/member/twolist', {
          groupId: this.groupInfo.id,
          type: this.searchType,
          userId: this.searchUid == null ? 0 : this.searchUid,
          lastId: lastId,
          pageSize: 15
        }).then((res) => {
          console.log('二级推广组====>',res)
          if (res.data.code == 0) {
            if (res.data.data.users.length == 0) {
              this.loading = false;
              this.refreshing = false
              this.finished = true;
              return
            }
            const uids = [];
            for (let user of res.data.data.users) {
              uids.push(user.userId);
              console.log('用户ID',uids)
            }
            this.$request.post('/api/user/info/userInfoByGroup', { userIds: JSON.stringify(uids) })
              .then((res1) => {
                this.loading = false
                this.refreshing = false
                if (res1.data.code == 0) {
                  const userMap = new Map();
                  for (let user of res1.data.data.users) {
                  
                      userMap.set(user.userId, user);
                 
                  }
                  for (let user of res.data.data.users) {
                    user.userInfo = userMap.get(user.userId);
                  }
                  this.list.push(...res.data.data.users)
                  this.finished = res.data.data.users.length < 15
                }
              })
          }
        })
      },
      onClickLeft() {
        routerUtil.back()
      },
      onClickRight() {
      },
      onSearch() {
        if (this.search == "") {
          this.searchUid = null
        } else {
          if (isNaN(Number(this.search, 10))) {
            Toast("请输入组长ID")
            return
          }
          const uid = parseInt(this.search);
          this.searchUid = uid;
        }
        this.searchType = parseInt(this.checked)
        this.list = [];
        this.onRefresh()
      },
      onLoad() {
        this.getList(true)
      },
      onRefresh() {
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.getList()
      },
      onEnableTapped(li) {
        this.confirm = true;
        this.item = li;
        this.isEnable = true;
      },
      onDisableTapped(li) {
        this.confirm = true;
        this.item = li;
        this.isEnable = false;
      },
      onConfirmTapped() {
        this.confirm = false;
        const status = this.isEnable ? 0 : 1;
        this.$request.postJson('/api/user/pay_group/member/change_status', {
          groupId: this.groupInfo.id,
          userId: this.item.userId,
          status: status
        }).then((res) => {
          if (res.data.code == 0) {
            this.item.status = status
          }
        })
      },
      onUidTapped(li) {
        copy(li.userId);
        Toast('组长ID已复制');
      },
      onInviteCodeTapped(li) {
        copy(li.code);
        Toast('组ID已复制');
      },
      onParentIdTapped(li) {
        if (!li.parentId) {
          return
        }
        copy(li.parentId);
        Toast('上级ID已复制');
      },
      onCopyUserIdTapped(li) {
        this.onUidTapped(li)
      },
      onIncomeTapped(li) {
        this.$router.push({
          name: 'twolevel',
          params: {
            userId: li.userId
          }
        });
      },
      getDisplayJoinTime(time) {
        const date = new Date(time);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const min = date.getMinutes();
        const sec = date.getSeconds();
        return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
      }
    },
  }
  </script>
  <style scoped lang="less">
    /* 全局容器样式 */
    .two-member-list-container {
        min-height: 100vh;
        background: linear-gradient(to bottom, #0a0a0a, #1a1a1a);
        color: #ffffff;
    }
    
    /* 内容包装器 */
    .content-wrapper {
        max-width: 1200px;
        margin: 0 auto;
        padding: 16px;
    }
    
    /* 搜索区域样式 */
    .search-section {
        background: #2a2a2a;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 16px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        border: 1px solid #3a3a3a;
    }
    
    .search-btn {
        color: #ffffff;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
        transition: color 0.3s ease;
    }
    
    .search-btn:hover {
        color: #388E3C;
    }
    
    /* 自定义搜索框样式（100%可控，无任何Vant变量干扰） */
    .custom-search {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      width: 100%;
      
      // 输入框容器（模拟round形状）
      .search-input-wrap {
        flex: 1;
        background: #3a3a3a;
        border-radius: 20px; // 对应原来的shape="round"
        padding: 8px 16px;
        box-sizing: border-box;
      }
      
      // 输入框
      .search-input {
        width: 100%;
        background: transparent;
        border: none;
        outline: none;
        color: #ffffff; // 输入文字颜色
        font-size: 14px;
        
        // 占位符样式（全浏览器兼容）
        &::placeholder {
          color: #909090;
          font-size: 14px;
        }
        &::-webkit-input-placeholder {
          color: #909090;
        }
        &:-moz-placeholder {
          color: #909090;
        }
      }
      
      // 搜索按钮
      .search-action-btn {
        color: #ffffff;
        font-size: 14px;
        font-weight: 500;
        padding: 8px 16px;
        cursor: pointer;
        white-space: nowrap;
      }
    }
    
    /* 搜索类型选择样式 */
    .search-type-wrapper {
        margin-top: 16px;
    }
    
    .radio-group {
        display: flex;
        gap: 20px;
    }
    
    /* 成员列表容器 */
    .member-list {
        padding-bottom: 20px;
    }
    
    /* 成员卡片样式 */
    .member-card {
        background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        border: 1px solid #3a3a3a;
    }
    
    .member-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(76, 175, 80, 0.2);
        border-color: #C8E6C9;
    }
    
    /* 成员头部信息 */
    .member-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 16px;
        border-bottom: 1px solid #3a3a3a;
        color: #ffffff;
    }
    
    .avatar-container {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 16px;
        border: 3px solid #4CAF50;
    }
    
    .avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .member-info {
        flex: 1;
        color: #ffffff;
    }
    
    .member-name {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 8px;
    }
    
    .join-time {
        font-size: 14px;
        color: #666666;
    }
    
    /* 成员数据信息 */
    .member-data {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 16px;
        margin-bottom: 20px;
        border-top: 1px solid #3a3a3a;
        padding-top: 16px;
    }
    
    .data-item {
        text-align: center;
        padding: 12px;
        background: #3a3a3a;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    
    .data-item:hover {
        background: #C8E6C9;
        transform: translateY(-1px);
    }
    
    .data-value {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 6px;
    }
    
    .data-label {
        font-size: 14px;
        color: #888888;
    }
    
    /* 操作按钮样式 */
    .action-buttons {
        display: flex;
        gap: 12px;
        justify-content: center;
    }
    
    .action-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 10px 20px;
        border-radius: 24px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    
    .copy-btn {
        background: #4a4a4a;
        color: white;
    }
    
    .copy-btn:hover {
        background: #5a5a5a;
        transform: translateY(-1px);
    }
    
    .income-btn {
        background: #5a5a5a;
        color: white;
    }
    
    .income-btn:hover {
        background: #6a6a6a;
        transform: translateY(-1px);
    }
    
    .icon-copy,
    .icon-income {
        font-size: 16px;
    }
    
    /* 确认弹窗样式 */
    .confirm-dialog {
        width: 280px;
        padding: 24px;
        text-align: center;
        background: #2a2a2a;
        border-radius: 12px;
    }
    
    .confirm-content {
        font-size: 16px;
        color: #ffffff;
        margin-bottom: 20px;
    }
    
    /* 响应式设计 */
    @media (max-width: 768px) {
        .member-data {
            grid-template-columns: 1fr;
        }
        
        .action-buttons {
            flex-direction: column;
        }
        
        .action-btn {
            justify-content: center;
        }
    }
    
    /* Vant 组件样式覆盖 */
    :deep(.van-radio__label) {
        color: #e0e0e0;
    }
    
    :deep(.van-radio__input--checked .van-radio__icon) {
        background-color: #666666;
        border-color: #666666;
    }
    
    :deep(.van-radio__input--checked .van-radio__label) {
        color: #666666;
    }
    
    /* 导航栏样式覆盖 - 确保所有文字为白色 */
    :deep(.van-nav-bar) {
        background-color: #1a1a1a !important;
        color: #ffffff !important;
    }
    
    :deep(.van-nav-bar__title) {
        color: #ffffff !important;
    }
    
    :deep(.van-nav-bar__text) {
        color: #ffffff !important;
    }
    
    :deep(.van-icon) {
        color: #ffffff !important;
    }
    

    
    :deep(.van-list__loading) {
        padding: 20px 0;
    }
    
    :deep(.van-list__finished-text) {
        color: #999;
        padding: 20px 0;
    }
    
    /* 动画效果 */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }
    
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
  </style>
